import(/* webpackMode: "eager", webpackExports: ["ReferralProgram"] */ "/app/src/components/footerStaticPages/referralProgram/index.tsx");
